// extracted by mini-css-extract-plugin
export default {"colorMain1":"#6d64c6","colorMain2":"#453ca2","wrapper":"styles_wrapper__pOl92","tagsWrapper":"styles_tagsWrapper__i+EfK","icon":"styles_icon__x+Ebf"};